import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PhotoToolbarPanelHeaderProps {
  title: string;
  onClose: () => void;
}

export function PhotoToolbarPanelHeader({ title, onClose }: PhotoToolbarPanelHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-sm font-medium text-white">{title}</span>
      <Button
        variant="ghost"
        size="icon-xs"
        aria-label="Close"
        className="text-gray-400 hover:bg-gray-800 hover:text-white"
        onClick={onClose}
      >
        <X aria-hidden="true" />
      </Button>
    </div>
  );
}
